import { Component, Input } from '@angular/core';
import { OmpHeadingSize } from '../../../_models';
import { OmpVideoAspectOptions } from '../../order-management-portal.sections';
import { OmpSectionSettings } from '..';

// Mirrors parseVideoUrl() in the React portal — if the editor accepts a link, the portal must be
// able to play it. Keep the two in step.
const YOUTUBE_PATTERNS = [
  /youtube\.com\/watch\?(?:.*&)?v=([\w-]{6,})/i,
  /youtu\.be\/([\w-]{6,})/i,
  /youtube\.com\/shorts\/([\w-]{6,})/i,
  /youtube\.com\/embed\/([\w-]{6,})/i,
];
const VIMEO_PATTERNS = [/vimeo\.com\/(?:video\/)?(\d{6,})/i, /player\.vimeo\.com\/video\/(\d{6,})/i];
// A direct, absolute http(s) link to a playable video file. Mirrors FILE_PATTERN in omp.ts.
const FILE_PATTERN = /\.(mp4|webm|mov|m4v|ogg|ogv)(?:[?#]|$)/i;

@Component({
  selector: 'omp-video-settings',
  templateUrl: './video-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
})
export class OmpVideoSettingsComponent extends OmpSectionSettings {
  public headingSize = OmpHeadingSize;
  public aspectOptions = OmpVideoAspectOptions;

  @Input() pageBackground = '';

  get previewBackground(): string {
    let background = this.pageBackground;
    if (this.data && this.data.display_inside_card && this.data.background_color) {
      background = this.data.background_color;
    }
    return background;
  }

  get urlWarning(): string {
    let warning = '';
    const url = this.data ? this.data.video_url : '';
    if (url && !this.isSupportedUrl(url)) {
      warning = "We can't play this link. Paste a YouTube, Vimeo, or direct video (.mp4) link.";
    }
    return warning;
  }

  private isSupportedUrl(url: string): boolean {
    const trimmed = url.trim();
    const embedPatterns = YOUTUBE_PATTERNS.concat(VIMEO_PATTERNS);
    if (embedPatterns.some((pattern) => pattern.test(trimmed))) {
      return true;
    }
    return /^https?:\/\//i.test(trimmed) && FILE_PATTERN.test(trimmed);
  }
}
